import React from 'react';
import { IoIosArrowForward } from 'react-icons/io';
import { Link } from 'react-router-dom';

export interface BreadcrumbsItem {
	name: string;
	link?: string;
}

interface BreadcrumbsProps {
	list: BreadcrumbsItem[];
}

function isExternalLink(link: string): boolean {
	return /^(https?:\/\/|mailto:|tel:)/.test(link);
}

export function Breadcrumbs({ list }: BreadcrumbsProps) {
	return (
		<ul className='mb-3 flex items-start justify-start text-[12px] leading-tight text-cogvio-900 tracking-wide'>
			{list.map((item, index) => (
				<li key={index} className='inline-flex items-center leading-5'>
					{index > 0 && <IoIosArrowForward className='w-4 h-4 mx-1 text-gray-500' />}
					{item.link ? (
						isExternalLink(item.link) ? (
							<a
								href={item.link}
								className='leading-5 underline decoration-2 underline-offset-2 decoration-gray-300 hover:text-black hover:decoration-black transition-colors hover:underline hover:decoration-2'
							>
								{item.name}
							</a>
						) : (
							<Link
								to={item.link}
								className='leading-5 underline decoration-2 underline-offset-2 decoration-gray-300 hover:text-black hover:decoration-black transition-colors hover:underline hover:decoration-2'
							>
								{item.name}
							</Link>
						)
					) : (
						<strong className='leading-5 font-normal'>{item.name}</strong>
					)}
				</li>
			))}
		</ul>
	);
}
